import { svg } from 'lit';

export const userContentIcon = svg`
  <circle cx="12" cy="12" r="8" fill="currentColor"/>
  `;
